import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppDispatch } from 'store';
import { openModal } from 'store/layoutSlice';
import Button from 'layout/atoms/Button';
import { ReactComponent as LanguageIcon } from 'assets/icons/language.svg';

const LanguageToggle = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();

    const handleClick = () => {
        dispatch(openModal({ name: 'language' }));
    };

    return (
        <Button size="m" align="left" onClick={handleClick} keepDropdownOpen>
            <LanguageIcon /> <span>{t('TOPBAR.LANGUAGE')}</span>
        </Button>
    );
};

export default LanguageToggle;
